<script lang="ts">
    import AppLayout from '@/layouts/app/AppHeaderLayout.svelte';
    import type { Snippet } from 'svelte';
    import type {ActionButtonType, BreadcrumbItemType, SectionLinkType} from "@/types/types";
    import {meta} from "@/meta.svelte";


    interface Props {
        breadcrumbs?: BreadcrumbItemType[];
        children?: Snippet;
        actionbuttons?: ActionButtonType[];
        csrfToken?: string;
        sectionLinks?: SectionLinkType[];
    }



    let { breadcrumbs = [], children, actionbuttons = [], csrfToken = '', sectionLinks = []}: Props = $props();

    if (typeof global === 'undefined') {
        window.global = window;
    }

</script>

<AppLayout {breadcrumbs} {actionbuttons} {sectionLinks}>
    {@render children?.()}
</AppLayout>
